// This import loads the firebase namespace along with all its type information.
import MediationStep from './mediation-step-model'

export async function load_mediationSteps(): Promise<MediationStep[]> {
  throw 'Not implemented'
}

export async function delete_mediationStep(): Promise<boolean> {
  throw 'Not implemented'
}

export async function store_mediationStep(): Promise<MediationStep> {
  throw 'Not implemented'
}
